import { Component } from '@angular/core';
import { DatePipe } from '@angular/common';
import { BaseCellComponent } from '@adnova/jf-ng-components';

import { AnnouncementTableItem } from '../+definitions';

/**
 * Datumsformat für die Anzeige in der Erstellt-am-Spalte.
 *
 * Format: Tag.Monat.Jahr (z.B. 01.12.2025)
 */
const DATE_FORMAT = 'dd.MM.yyyy';

/**
 * Cell-Komponente für die Erstellt-am-Spalte in der Announcement-Tabelle.
 *
 * Zeigt das Erstellungsdatum des Announcements im Format "DD.MM.YYYY" an.
 * Das Datum stammt aus dem Feld `createdAt`.
 *
 * @extends BaseCellComponent<AnnouncementTableItem>
 */
@Component({
  selector: 'app-date-cell',
  standalone: true,
  imports: [DatePipe],
  templateUrl: './date-cell.component.html',
})
export class DateCellComponent extends BaseCellComponent<AnnouncementTableItem> {

  /**
   * Datumsformat für die Anzeige.
   * Wird im Template verwendet.
   */
  readonly dateFormat = DATE_FORMAT;
}
